import { CONVERSATION_SOURCES } from '../constants';

export const gaId = process.env.REACT_APP_GA_ID;
export const inboxDesktopUrl = process.env.REACT_APP_INBOX_DESKTOP_URL;
export const inboxDownloadUrl = process.env.REACT_APP_INBOX_DOWNLOAD_URL;
export const GET_TEAMS_INTERVAL = 5000;
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};
export const liveConversationSourceIds = [1, 4, 6, 10, 11, 12, 13, 14];

export const conversationSourceIds = {
  1: CONVERSATION_SOURCES.MESSENGER,
  2: CONVERSATION_SOURCES.INBOX,
  3: CONVERSATION_SOURCES.SLACK_MSP,
  4: CONVERSATION_SOURCES.SLACK_CLIENT,
  5: CONVERSATION_SOURCES.MS_TEAMS_MSP,
  6: CONVERSATION_SOURCES.MS_TEAMS_CLIENT_CHANNEL,
  7: CONVERSATION_SOURCES.PSA,
  8: CONVERSATION_SOURCES.PROVIDER,
  9: CONVERSATION_SOURCES.ACTION_PLATFORM,
  10: CONVERSATION_SOURCES.MS_TEAMS_CLIENT_PERSONAL,
  11: CONVERSATION_SOURCES.MESSENGER_AGENT,
  12: CONVERSATION_SOURCES.MESSENGER_WIDGET,
  13: CONVERSATION_SOURCES.MESSENGER_TEAMS,
  14: CONVERSATION_SOURCES.MESSENGER_MOBILE,
  15: CONVERSATION_SOURCES.INBOX_PODS
};

export const CCMEnabledCompanyIds = [291014, 126];
export const userPilotToken = process.env.REACT_APP_USER_PILOT_ID;
